export const FETCH_OWNERS_START = 'FETCH_OWNERS_START';
export const FETCH_OWNERS_SUCCESS = 'FETCH_OWNERS_SUCCESS';
export const FETCH_OWNERS_FAIL = 'FETCH_OWNERS_FAIL';

export const FETCH_USERS_START = 'FETCH_USERS_START';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAIL = 'FETCH_USERS_FAIL';

export const CREATE_USER_START = 'CREATE_USER_START';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

export const UPDATE_USER_START = 'UPDATE_USER_START';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const DELETE_USER_START = 'DELETE_USER_START';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const FETCH_ME_START = 'FETCH_ME_START';
export const FETCH_ME_SUCCESS = 'FETCH_ME_SUCCESS';
export const FETCH_ME_FAIL = 'FETCH_ME_FAIL';

export const FETCH_MY_DOCUMENTS_START = 'FETCH_MY_DOCUMENTS_START';
export const FETCH_MY_DOCUMENTS_SUCCESS = 'FETCH_MY_DOCUMENTS_SUCCESS';
export const FETCH_MY_DOCUMENTS_FAIL = 'FETCH_MY_DOCUMENTS_FAIL';

export const RESET_CREATED_USER = 'RESET_CREATED_USER';
export const RESET_MY_DOCUMENTS_STORE = 'RESET_MY_DOCUMENTS_STORE';
export const RESET_USER_STORE = 'RESET_USER_STORE';

export const SET_SAVED_FILTERS = 'SET_SAVED_FILTERS';

export type UserActionTypes =
  | typeof FETCH_OWNERS_START
  | typeof FETCH_OWNERS_SUCCESS
  | typeof FETCH_OWNERS_FAIL
  | typeof FETCH_USERS_START
  | typeof FETCH_USERS_SUCCESS
  | typeof FETCH_USERS_FAIL
  | typeof CREATE_USER_START
  | typeof CREATE_USER_SUCCESS
  | typeof CREATE_USER_FAIL
  | typeof UPDATE_USER_START
  | typeof UPDATE_USER_SUCCESS
  | typeof UPDATE_USER_FAIL
  | typeof DELETE_USER_START
  | typeof DELETE_USER_SUCCESS
  | typeof DELETE_USER_FAIL
  | typeof FETCH_ME_START
  | typeof FETCH_ME_SUCCESS
  | typeof FETCH_ME_FAIL
  | typeof FETCH_MY_DOCUMENTS_START
  | typeof FETCH_MY_DOCUMENTS_SUCCESS
  | typeof FETCH_MY_DOCUMENTS_FAIL
  | typeof RESET_MY_DOCUMENTS_STORE
  | typeof RESET_CREATED_USER
  | typeof SET_SAVED_FILTERS
  | typeof RESET_USER_STORE;
